function ComingSoon({ title }) {
  return (
    <main style={{ minHeight: "60vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#f8fafc" }}>
      <div style={{ textAlign: "center" }}>
        <div style={{ fontSize: "56px", marginBottom: "16px" }}>🚧</div>
        <h1 style={{ fontFamily: "'Sora', sans-serif", fontSize: "28px", fontWeight: "900", color: "#1a1a2e" }}>
          {title} — Coming Soon
        </h1>
        <p style={{ color: "#6b7280", fontFamily: "'DM Sans', sans-serif", marginTop: "8px" }}>
          We're building something great. Stay tuned!
        </p>
      </div>
    </main>
  );
}
export default ComingSoon;